import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, getDoc, deleteDoc, doc, } from "firebase/firestore";
import { db } from "../Firebase/firebaseConfig/firebase";
import { async } from "@firebase/util";
import '../../style/Carrito.css';
import { useAuth } from '../AuthContext';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);


export default function Carrito() {
  //1 configuración de los hook de mostrar
  const carritoCollection = collection(db, "Cart");
  const [carrito, setcarrito] = useState([]);
	const { userId, setAuthUserId } = useAuth();

  useEffect(() => {
    // Hacer algo con el userId
    console.log('UserID:', userId);
  }, [userId]);

  //3 creamos la funcionabilidad para mostrar los documentos con asincronismo
  const getcarrito = async () => {
    const data = await getDocs(carritoCollection);
    console.log(data.docs);

    setcarrito(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    getcarrito();
  }, []);

  //4 declaración función delete para eliminar registros
  console.log(carrito);
  const deletecarrito = async (id) => {
    const carritoDoc = doc(db, "Cart", id);
    await deleteDoc(carritoDoc);
    getcarrito();
  };

  //5 configuración sweetalert
  const confirmDelete = (id) => {
    Swal.fire({
      title: "Vas a quitar el producto del carrito?",
      text: "Seguro de querer quitarlo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Quita!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletecarrito(id);
        Swal.fire("Quitado", "El producto fue quitado.", "Listo");
      }
    });
  };

  //6 declaramos el useEffect

	// Calcular la suma de los precios
  const totalPrecio = carrito.reduce((total, cartItem) => total + parseFloat(cartItem.Precio * cartItem.Cantidad || 0), 0);
	// Concatenar todos los textos con saltos de línea
	var mensajeWhatsApp = "*Pedido:* \n" 
	mensajeWhatsApp += carrito.map(
    (Cart) => `${Cart.Nombre} - $${Cart.Precio || 0} * ${Cart.Cantidad || 0} = $${Cart.Cantidad * Cart.Precio || 0}`
  ).join('\n');
	mensajeWhatsApp += `\nTotal: $${totalPrecio.toFixed(2)}`;

  //7 mostrar datos en estructura

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="d-grid gap-2">
            {/* <Link
              to="/crearcarrito"
              className="btn btn-primary btn-lg mt-3 mb-4 w-25"
            >Crear Nuevo <i className="fa-solid fa-plus"></i>
            </Link> */}
          </div>
          <div className="d-grid gap-2 mt-4">
          <table className="table table-dark table-hover">
            <thead>
              <tr>
                {/* <th className="text-sm">UID</th> */}
								<th>Nombre</th>
                <th className="text-light text-end">Precio</th>
                <th className="text-light text-end">Cantidad</th>
                <th className="text-light text-end d-none d-sm-table-cell">Total</th>
                <th className="text-light text-center">Acciones</th>
              </tr>
            </thead>
            <tbody className="text-light">
              {carrito.map((Cart) => (
              Cart.UID === userId && (
								<tr key={Cart.id}>
                  {/* <td key={Cart.UID} className="text-light">
                    {Cart.UID || ""}
                  </td> */}
                  <td key={Cart.Nombre} className="text-light">
                    {Cart.Nombre || ""}
                  </td>
                  <td key={Cart.Precio} className="text-light text-end col-3">
									$ {Cart.Precio || ""}
                  </td>
                  <td key={Cart.Cantidad} className="text-light text-end col-md-2 col-sm-3">
                    {Cart.Cantidad || ""}{" "}
                  </td>
                  <td className="text-light text-end col-md-2 col-sm-3 d-none d-sm-table-cell">
                  $  {Cart.Cantidad * Cart.Precio || ""}{" "}
                  </td>
                  <td className="text-light text-center col-3">
                    <Link
                      to={`/editarcarrito/${Cart.id}`}
                      className="btn btn-light mx-1 btn-sm"
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </Link>
                    <button
                      onClick={() => {
                        confirmDelete(Cart.id);
                      }}
                      className="btn btn-danger btn-sm"
                    >
                      <i className="fa-solid fa-trash "></i>
                    </button>
                  </td>
                </tr>
							)
              ))}
            </tbody>
          </table>
					</div>
					<div className="text-end mt-3">
            <strong>Total: $ {totalPrecio.toFixed(2)}</strong>
          </div>
        </div>
      </div>
			<div className="row">
				<div className="col text-end">
					<Link target="_blank" to={`https://api.whatsapp.com/send?phone=5493774514451&text=${encodeURIComponent(mensajeWhatsApp)}`} className="btn btn-outline-success btn-lg mt-3 mb-4 border border-success border-3 whatsapp-icon"><i class="fab fa-whatsapp"></i> ¡Comprar!</Link>
				</div>
			</div>
    </div>
  );
}
